import { createFeature } from '@ngrx/store';
import {
  SpxState,
  spxCreateApiReducer,
  spxCreateInitialStateForReducer,
} from '@softpak/components/spx-redux';
import { RfrCplLocationsQueryI } from 'src/app/api/rfr-cpl-locations/rfr-cpl-locations.query.int';
import { RfrCplLocationsI } from 'src/app/api/rfr-cpl-locations/rfr-cpl-locations.result.int';
import { RfrCplLocationsActions } from './rfr-cpl-locations.actions';

export type State = SpxState<RfrCplLocationsQueryI, RfrCplLocationsI, string>;

export const initialState: State =
  spxCreateInitialStateForReducer<RfrCplLocationsQueryI, RfrCplLocationsI, string>();

export default createFeature({
  name: 'rfrCplLocations',
  reducer: spxCreateApiReducer(RfrCplLocationsActions, initialState),
});
